import { useEffect } from "react";
import type { PrewarmRequest } from "@b2bportal/rbc-hts-assist-api";
import { pathnameToEntryPoint } from "./htsAssistEntryPoint";
import { pathnameToSupportContext } from "./htsAssistSupportContext";
import {
  HTS_ASSIST_PREWARM_CACHE_SECONDS,
  htsAssistPrewarmApi,
} from "@/api/htsAssist/prewarmApi";

type BuildHtsAssistPrewarmRequestOptions = {
  isEnabled: boolean;
  isLauncherVisible: boolean;
  pathname: string;
};

const PREWARM_PRODUCT_TYPES = new Set(["flight", "hotel", "car"]);

export const buildHtsAssistPrewarmRequest = ({
  isEnabled,
  isLauncherVisible,
  pathname,
}: BuildHtsAssistPrewarmRequestOptions): PrewarmRequest | undefined => {
  if (!isEnabled || !isLauncherVisible) return undefined;

  if (pathnameToEntryPoint(pathname) === "home") return {};

  const supportContext = pathnameToSupportContext(pathname);
  if (supportContext && PREWARM_PRODUCT_TYPES.has(supportContext.productType)) {
    return { supportContext };
  }

  return undefined;
};

export const useHtsAssistPrewarm = (
  request: PrewarmRequest | undefined
): void => {
  const prewarm = htsAssistPrewarmApi.usePrefetch("prewarm", {
    ifOlderThan: HTS_ASSIST_PREWARM_CACHE_SECONDS,
  });

  useEffect(() => {
    if (request) prewarm(request);
  }, [prewarm, request]);
};
